import { Language } from './settings/language/language.enum'

const config = {
    language: Language.Norwegian,
    localStorageLangKey: 'language',
}

export default config
